import { start } from "./ujs";
import { DirectUpload } from "./direct_upload";
const isServer = !(
  typeof window !== "undefined" &&
  window.document &&
  window.document.createElement
);

export { start, DirectUpload };

function autostart() {
  if (!isServer && window.ActiveStorage) {
    start();
  }
}

setTimeout(autostart, 1);
